const initSwipers = () => {
    const mobileSwipers = document.querySelectorAll('.swiper-mobile');
    if (mobileSwipers.length) {
        mobileSwipers.forEach((mobileSwiper) => {
            new Swiper(mobileSwiper, {
                slidesPerView: 1,
                autoHeight: true,
                pagination: {
                    el: ".swiper-pagination",
                },
            });
        });
    }
};

const initProductsHighlightSwipers = () => {
    const swipers = document.querySelectorAll('.products-highlight__swiper');
    swipers.forEach((swiperEl) => {
        if (swiperEl.swiper) return;
        const wrapper = swiperEl.closest('.products-highlight__wrapper') || swiperEl.parentElement;
        // Suggestions produits (fiche produit) = 4 par ligne ; coups de cŒur (HP) = 5 par ligne
        const isRecommendations = !!swiperEl.closest('product-recommendations');
        const perView = isRecommendations ? 4 : 5;
        new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: wrapper.querySelector('.swiper-button-next'),
                prevEl: wrapper.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: perView,
                    spaceBetween: 20,
                    slidesPerGroup: perView
                },
            },
        });
    });
};

const initSwiperSubCategories = () => {
    const swiperSubCategory = document.querySelector('.collection-subcategories .swiper');
    if (swiperSubCategory) {
        new Swiper('.collection-subcategories .swiper', {
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
                480: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                },
                1200: {
                    slidesPerView: 6,
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
};

const initProductCoverSlider = () => {
    if(!document.body.dataset.template === "product") return;
    
    const thumbnails = Array.from(document.querySelectorAll(".product__media-wrapper .thumbnail"));
    const nextButton = document.querySelector(".product__media-viewer .slider-button--next");
    const prevButton = document.querySelector(".product__media-viewer .slider-button--prev");

    const getActiveIndex = () => thumbnails.findIndex(thumb => thumb.hasAttribute("aria-current"));

    const triggerThumbnailClick = (direction) => {
        const currentIndex = getActiveIndex();
        if (currentIndex === -1) return;

        const newIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;
        if (thumbnails[newIndex]) {
            thumbnails[newIndex].click();
        }
    };

    if (nextButton) {
        nextButton.addEventListener("click", () => triggerThumbnailClick("next"));
    }
    if (prevButton) {
        prevButton.addEventListener("click", () => triggerThumbnailClick("prev"));
    }
};

const initTooltips = () => {
    // Crée l'élément tooltip
    const tooltip = document.createElement("div");
    tooltip.className = "tooltip";
    document.body.appendChild(tooltip);

    // Gère l'affichage du tooltip
    const showTooltip = (e) => {
        const text = e.target.getAttribute("data-tooltip");
        if (!text) return;

        tooltip.textContent = text;
        tooltip.style.display = "block";
        tooltip.style.left = `${e.pageX + 10}px`;
        tooltip.style.top = `${e.pageY + 10}px`;
    };

    // Masque le tooltip
    const hideTooltip = () => {
        tooltip.style.display = "none";
    };

    // Met à jour la position du tooltip
    const moveTooltip = (e) => {
        tooltip.style.left = `${e.pageX + 10}px`;
        tooltip.style.top = `${e.pageY + 10}px`;
    };

    // Attache les événements aux éléments avec data-tooltip
    document.querySelectorAll("[data-tooltip]").forEach(el => {
        el.addEventListener("mouseenter", showTooltip);
        el.addEventListener("mouseleave", hideTooltip);
        el.addEventListener("mousemove", moveTooltip);
    });
};

const togglePasswordVisibility = () => {
    const $createCustomerFormPassword = document.querySelector('input[name="customer[password]"]');
    const $createCustomerFormPasswordToggle = document.querySelector('#show-password');

    if (!$createCustomerFormPassword || !$createCustomerFormPasswordToggle) return;

    $createCustomerFormPasswordToggle.addEventListener("click", () => {
        const type = $createCustomerFormPassword.type === "password" ? "text" : "password";
        $createCustomerFormPassword.type = type;
        // $createCustomerFormPasswordToggle.textContent = type === "password" ? "👁️" : "🙈";
        if (type === "password") {
            $createCustomerFormPasswordToggle.classList.remove('show-password--closed');
        } else {
            $createCustomerFormPasswordToggle.classList.add('show-password--closed');
        }
        
    });
}

const moveCartRewardsToCartPage = () => {
    const cartRewards = document.querySelector('[data-main-cart-rewards-container]');
    const sidecartDrawer = document.querySelector('#cart-drawer-container');
    
    if (cartRewards && sidecartDrawer) {
        const sidecartRewards = sidecartDrawer.querySelector('.cd-rewards-container');
        if (!sidecartRewards) return;

        cartRewards.innerHTML = '';
        cartRewards.appendChild(sidecartRewards.cloneNode(true));
    }
};

const handleEmptyCart = () => {
    const emptyCartBtn = document.getElementById('empty-cart-btn');
    if (!emptyCartBtn) return;
    emptyCartBtn.addEventListener('click', (e) => {
        e.preventDefault();

        fetch('/cart/clear.js', { method: 'POST' })
            .then(response => response.json())
            .then(data => {
                window.location.reload(); // recharge la page pour voir le panier vide
            });
    });
};

const moveCartElementsMobile = () => {
    const cartSuggestions = document.querySelector('[data-main-cart-suggestions]');
    const cartSuggestionsMobile = document.querySelector('[data-main-cart-suggestions-mobile]');

    if (cartSuggestions && cartSuggestionsMobile) {
        cartSuggestionsMobile.innerHTML = '';
        cartSuggestionsMobile.appendChild(cartSuggestions);
    }
};

const initCart = () => {
    handleEmptyCart();
    
    document.addEventListener('la:dn:cart-mutations:processed', (e) => {
        moveCartRewardsToCartPage();
    });

    if (window.innerWidth <= 1280) {
        moveCartElementsMobile();
    }
};

// Génère des variantes de la requête en préfixant les élisions françaises
// (d', l', s') si le premier mot commence par une voyelle ou un h. Permet
// de matcher "Graines d'épinards" quand l'utilisateur tape "épinards".
const buildPredictiveSearchVariants = (searchTerm) => {
    const variants = [searchTerm];
    if (searchTerm.length < 2) return variants;
    const firstWord = searchTerm.split(/\s+/)[0];
    if (/^[aeiouhàâäéèêëîïôöùûüœæ]/i.test(firstWord)) {
        variants.push(`d'${searchTerm}`, `l'${searchTerm}`, `s'${searchTerm}`);
    }
    return variants;
};

const mergePredictiveSearchResults = (htmls) => {
    const parser = new DOMParser();
    const sections = htmls
        .filter((html) => html)
        .map((html) =>
            parser.parseFromString(html, 'text/html').querySelector('#shopify-section-predictive-search')
        )
        .filter((section) => section);

    if (sections.length === 0) return '';

    const baseSection =
        sections.find((s) => s.querySelector('.desktop-search__results-wrapper')) || sections[0];

    if (!baseSection.querySelector('.desktop-search__results-wrapper')) {
        return baseSection.innerHTML;
    }

    const groupConfigs = [
        { cls: 'predictive-group--products', limit: 10, parent: '.desktop-search__results-wrapper', insert: 'prepend' },
        { cls: 'predictive-group--collections', limit: 4, parent: '.desktop-search__results-right', insert: 'prepend' },
        { cls: 'predictive-group--articles', limit: 3, parent: '.desktop-search__results-right', insert: 'append' },
    ];

    groupConfigs.forEach(({ cls, limit, parent, insert }) => {
        let baseGroup = baseSection.querySelector(`.${cls}`);

        if (!baseGroup) {
            for (const section of sections) {
                const candidate = section.querySelector(`.${cls}`);
                if (candidate) {
                    baseGroup = candidate.cloneNode(true);
                    const parentEl = baseSection.querySelector(parent);
                    if (parentEl) {
                        if (insert === 'prepend') parentEl.prepend(baseGroup);
                        else parentEl.appendChild(baseGroup);
                    }
                    break;
                }
            }
        }

        if (!baseGroup) return;
        const baseList = baseGroup.querySelector('ul');
        if (!baseList) return;

        // Dédup par path (pas par href complet) car Shopify ajoute des
        // querystrings différents (_psq, _pos…) selon la requête source,
        // ce qui ferait passer 3 URLs pour 3 cibles distinctes.
        const hrefKey = (href) => {
            try {
                return new URL(href, window.location.origin).pathname;
            } catch (e) {
                return href.split('?')[0];
            }
        };

        const seen = new Set(
            Array.from(baseList.querySelectorAll('a'))
                .map((a) => a.getAttribute('href'))
                .filter(Boolean)
                .map(hrefKey)
        );

        for (const section of sections) {
            if (baseList.children.length >= limit) break;
            const items = section.querySelectorAll(`.${cls} ul li`);
            items.forEach((li) => {
                if (baseList.children.length >= limit) return;
                const href = li.querySelector('a')?.getAttribute('href');
                if (!href) return;
                const key = hrefKey(href);
                if (seen.has(key)) return;
                seen.add(key);
                baseList.appendChild(li.cloneNode(true));
            });
        }
    });

    return baseSection.innerHTML;
};

const initPredictiveSearch = () => {
    const searchFields = document.querySelectorAll('.desktop-search');

    // Un seul listener global
    document.addEventListener('click', function (event) {
        searchFields.forEach((searchField) => {
            const input = searchField.querySelector('#predictive-search-input');
            const resultsContainer = searchField.querySelector('#predictive-search-results');
            const clearBtn = searchField.querySelector('#clear-search-btn');

            // On ferme SEULEMENT si on clique en dehors de ce champ
            if (!searchField.contains(event.target)) {
                input.value = '';
                clearBtn.style.display = 'none';
                resultsContainer.innerHTML = '';
                resultsContainer.style.display = 'none';
            }
        });
    });

    // Listener par champ
    searchFields.forEach((searchField) => {
        const input = searchField.querySelector('#predictive-search-input');
        const resultsContainer = searchField.querySelector('#predictive-search-results');
        const clearBtn = searchField.querySelector('#clear-search-btn');
        let debounceTimer;

        const updateResultsVisibility = () => {
            const hasContent = resultsContainer.innerHTML.trim().length > 0;
            resultsContainer.style.display = hasContent ? 'block' : 'none';
        };

        const clearSearch = () => {
            input.value = '';
            clearBtn.style.display = 'none';
            resultsContainer.innerHTML = '';
            updateResultsVisibility();
            input.focus();
        };

        input.addEventListener('input', function () {
            const query = this.value.trim();
            clearBtn.style.display = query.length > 0 ? 'inline-block' : 'none';

            clearTimeout(debounceTimer);

            if (query.length < 2) {
                resultsContainer.innerHTML = '';
                updateResultsVisibility();
                return;
            }

            debounceTimer = setTimeout(async () => {
                try {
                    const variants = buildPredictiveSearchVariants(query);
                    const responses = await Promise.all(
                        variants.map((q) =>
                            fetch(`/search/suggest?q=${encodeURIComponent(q)}&resources[type]=query,product,article,collection&resources[limit]=8&resources[limit_scope]=each&section_id=predictive-search`)
                                .then((r) => (r.ok ? r.text() : ''))
                                .catch(() => '')
                        )
                    );
                    resultsContainer.innerHTML = mergePredictiveSearchResults(responses);
                    updateResultsVisibility();
                } catch (error) {
                    console.error('Erreur predictive search:', error);
                }
            }, 300);
        });

        input.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') clearSearch();
        });

        input.addEventListener('focus', function () {
            const $openDrawerSummary = document.querySelector(
                'header-drawer details[open] > summary.header__icon--menu'
            );
            if ($openDrawerSummary) $openDrawerSummary.click();
        });

        clearBtn.addEventListener('click', clearSearch);
    });
};


const initAccountActivation = () => {
    const $accountActivationForm = document.querySelector('#activate-account-form');
    const $message = $accountActivationForm?.querySelector('#activate-account-message');
    const $submitButton = $accountActivationForm?.querySelector('button[type="submit"]');

    if (!$accountActivationForm || !$message || !$submitButton) return;

    $accountActivationForm.addEventListener('submit', async (event) => {
        event.preventDefault();

        const $accountActivationEmail = $accountActivationForm.querySelector('input[name="activate-account-email"]');
        const email = $accountActivationEmail?.value?.trim().toLowerCase();

        // Nettoyer les anciens messages
        $message.textContent = '';
        $message.className = ''; // retire toutes les classes

        if (!email) {
            $message.textContent = 'Veuillez saisir une adresse e-mail.';
            $message.classList.add('activate-account-message--error');
            return;
        }

        // Désactiver le bouton et indiquer "envoi en cours"
        $submitButton.disabled = true;
        const originalText = $submitButton.textContent;
        $submitButton.textContent = 'Envoi en cours...';

        try {
            const response = await fetch('https://apishopify.fermedesaintemarthe.com/activate-account.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) {
                throw new Error(`Erreur serveur (${response.status})`);
            }

            const data = await response.json();

            if (data.success) {
                $message.textContent = data.message || 'Lien d’activation généré avec succès.';
                $message.classList.add('activate-account-message--success');
                $accountActivationForm.reset();

                if (data.activationUrl) {
                    document.location.href = data.activationUrl;
                }
            } else {
                if (data.errorCode) {
                    switch (data.errorCode) {
                    case 'ALREADY_ACTIVE':
                        $message.innerHTML = `<b>Votre compte est déjà activé</b>,<br/> 
                            Nous vous invitons à vous connecter avec votre mot de passe : <a href="#">j'accède à mon compte</a> ou en le réinitialisant ici : <a href="#recover">j’ai oublié mon mot de passe</a>.`;
                        break;
                    }
                } else {
                    $message.textContent = data.message || 'Une erreur est survenue.';
                }
                $message.classList.add('activate-account-message--error');
            }
        } catch (error) {
            console.error('Erreur lors de la requête :', error);
            $message.textContent = 'Une erreur est survenue. Veuillez réessayer.';
            $message.classList.add('activate-account-message--error');
        } finally {
            // Réactiver le bouton et remettre le texte original
            $submitButton.disabled = false;
            $submitButton.textContent = originalText;
        }
    });
};

const initRecoverPasswordCheck = () => {
    const $form = document.querySelector('#RecoverPasswordForm');
    const $message = document.querySelector('#recover-password-message');
    const $emailInput = $form?.querySelector('input[name="email"]');
    const $submitButton = $form?.querySelector('button[type="submit"], button:not([type])');

    if (!$form || !$message || !$emailInput || !$submitButton) return;

    let bypassCheck = false;

    $form.addEventListener('submit', async (event) => {
        if (bypassCheck) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        const email = $emailInput.value?.trim().toLowerCase();
        console.log('[recover-check] submit intercepted, email=', email);

        $message.textContent = '';
        $message.className = '';

        if (!email) {
            $message.textContent = 'Veuillez saisir une adresse e-mail.';
            $message.classList.add('recover-password-message--error');
            return;
        }

        $submitButton.disabled = true;
        const originalText = $submitButton.textContent;
        $submitButton.textContent = 'Vérification...';

        const submitNatively = () => {
            bypassCheck = true;
            $form.submit();
        };

        try {
            const response = await fetch('https://apishopify.fermedesaintemarthe.com/check-account.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) throw new Error(`Erreur serveur (${response.status})`);

            const data = await response.json();
            console.log('[recover-check] API response:', data);

            if (data.exists === true) {
                console.log('[recover-check] account found, submitting natively');
                submitNatively();
                return;
            }

            if (data.exists === false) {
                console.log('[recover-check] no account, showing message');
                $message.innerHTML = `Aucun compte n'est associé à cette adresse e-mail.<br/><a href="/account/register">Créer un compte</a>`;
                $message.classList.add('recover-password-message--error');
                $submitButton.disabled = false;
                $submitButton.textContent = originalText;
                return;
            }

            console.warn('[recover-check] unexpected payload, falling back to native submit');
            submitNatively();
        } catch (error) {
            console.error('[recover-check] error, falling back to native submit:', error);
            submitNatively();
        }
    });
};

const initModals = () => {
    // OUVERTURE
    document.querySelectorAll('[data-toggle-modal]').forEach(trigger => {
        trigger.addEventListener('click', e => {
        e.preventDefault();
        const selector = trigger.getAttribute('data-toggle-modal');
        const modal = document.querySelector(selector);
        if (modal) modal.classList.add('active');
        });
    });

    // FERMETURE
    document.querySelectorAll('.sld-modal').forEach(modal => {
        const closeBtn = modal.querySelector('.sld-modal__close');
        const overlay = modal.querySelector('.sld-modal__overlay');

        if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            modal.classList.remove('active');
        });
        }

        if (overlay) {
        overlay.addEventListener('click', () => {
            modal.classList.remove('active');
        });
        }
    });
};

let stickyProductBuyBoxCleanup;
let stickyProductBuyBoxElement;
let stickyProductBuyBoxObserver;

const isProductTemplate = () => document.body.dataset.template?.startsWith('product');

const initStickyProductBuyBox = () => {
    if (!isProductTemplate()) return;

    const buyAndQty = document.querySelector('.product__buy-and-qty');
    const priceContainer = document.querySelector('[data-la-dn-price]');
    const footer = document.querySelector('.footer') || document.querySelector('footer');
    const mobileBreakpoint = window.matchMedia('(max-width: 768px)');
    const desktopBreakpoint = window.matchMedia('(min-width: 769px)');

    if (!buyAndQty) return;

    if (stickyProductBuyBoxElement === buyAndQty) return;

    stickyProductBuyBoxCleanup?.();
    stickyProductBuyBoxElement = buyAndQty;

    const originalParent = buyAndQty.parentElement;

    if (!originalParent) return;

    const originalBuyBoxDocumentTop = buyAndQty.getBoundingClientRect().top + window.scrollY;

    const priceTargets = Array.from(buyAndQty.querySelectorAll('[data-mobile-buybox-price]'));
    const placeholder = document.createElement('div');
    placeholder.className = 'product__buy-and-qty-placeholder';
    originalParent.insertBefore(placeholder, buyAndQty);

    const stickyTrigger = document.createElement('div');
    stickyTrigger.className = 'product__buy-and-qty-trigger';
    originalParent.insertBefore(stickyTrigger, buyAndQty.nextSibling);

    let footerObserver;
    let resizeObserver;
    let priceObserver;
    let currentMode;
    let footerVisible = false;
    let shouldStickOnDesktop = false;
    let desktopStickyFrame;

    const getDesktopStickyThreshold = () => {
        const headerWrapper = document.querySelector('.header-wrapper');
        return headerWrapper ? headerWrapper.getBoundingClientRect().bottom : 0;
    };

    const getPortalRoot = () => {
        let portalRoot = document.getElementById('sticky-buy-and-qty-root');

        if (!portalRoot) {
            portalRoot = document.createElement('div');
            portalRoot.id = 'sticky-buy-and-qty-root';
            document.body.appendChild(portalRoot);
        }

        return portalRoot;
    };

    const moveBuyBoxToBody = () => {
        const portalRoot = getPortalRoot();

        if (!portalRoot.contains(buyAndQty)) {
            portalRoot.appendChild(buyAndQty);
        }
    };

    const restoreBuyBoxPosition = () => {
        if (placeholder.parentElement && placeholder.nextElementSibling !== buyAndQty) {
            placeholder.after(buyAndQty);
        } else if (!placeholder.parentElement && buyAndQty.isConnected) {
            buyAndQty.remove();
        }

        const portalRoot = document.getElementById('sticky-buy-and-qty-root');
        if (portalRoot && !portalRoot.children.length) {
            portalRoot.remove();
        }
    };

    const syncStickyPrice = () => {
        if (!priceTargets.length || !priceContainer) return;

        const activePrice = priceContainer.querySelector(
            '.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--sale, .price-item--regular'
        );

        if (activePrice) {
            const priceText = activePrice.textContent.replace(/\s+/g, ' ').trim();
            priceTargets.forEach((priceTarget) => {
                priceTarget.textContent = priceText;
            });
        }
    };

    const updatePlaceholderHeight = () => {
        if (currentMode !== 'desktop') {
            placeholder.style.removeProperty('height');
            return;
        }

        window.requestAnimationFrame(() => {
            const height = Math.ceil(buyAndQty.getBoundingClientRect().height);
            placeholder.style.height = `${height}px`;
        });
    };

    // Expose the sticky banner height so floating widgets (scroll-to-top arrow,
    // Axeptio cookies button) can be offset above it instead of being covered.
    const updateStickyOffset = () => {
        const active = Boolean(currentMode) && !footerVisible;

        if (!active) {
            document.body.classList.remove('has-sticky-buybox');
            document.body.style.removeProperty('--sticky-buybox-height');
            return;
        }

        window.requestAnimationFrame(() => {
            if (!currentMode || footerVisible) return;
            const height = Math.ceil(buyAndQty.getBoundingClientRect().height);
            document.body.style.setProperty('--sticky-buybox-height', `${height}px`);
            document.body.classList.add('has-sticky-buybox');
        });
    };

    const getReferenceBuyBoxRect = () => {
        if (currentMode === 'desktop') {
            return placeholder.getBoundingClientRect();
        }

        return buyAndQty.getBoundingClientRect();
    };

    const handleFooterVisibility = (entries) => {
        footerVisible = Boolean(entries[0]?.isIntersecting);
        buyAndQty.classList.toggle('product__buy-and-qty--hidden', footerVisible && Boolean(currentMode));
        updateStickyOffset();
    };

    const requestDesktopStickyUpdate = () => {
        if (desktopStickyFrame) return;

        desktopStickyFrame = window.requestAnimationFrame(() => {
            desktopStickyFrame = undefined;
            const buyBoxRect = getReferenceBuyBoxRect();
            const stickyThreshold = getDesktopStickyThreshold();
            const stickyViewportTop = window.scrollY + stickyThreshold;

            shouldStickOnDesktop = stickyViewportTop >= originalBuyBoxDocumentTop;

            updateStickyBuyBox();
        });
    };

    const disconnectStickyObservers = () => {
        footerObserver?.disconnect();
        resizeObserver?.disconnect();
        priceObserver?.disconnect();
        footerObserver = undefined;
        resizeObserver = undefined;
        priceObserver = undefined;
    };

    const observeStickyState = () => {
        if (window.ResizeObserver && !resizeObserver) {
            resizeObserver = new ResizeObserver(() => {
                updatePlaceholderHeight();
                updateStickyOffset();
            });
            resizeObserver.observe(buyAndQty);
        }

        if (priceContainer && !priceObserver) {
            priceObserver = new MutationObserver(() => {
                syncStickyPrice();
                updatePlaceholderHeight();
                updateStickyOffset();
            });

            priceObserver.observe(priceContainer, {
                childList: true,
                subtree: true,
                characterData: true,
            });
        }

        if (footer && !footerObserver) {
            footerObserver = new IntersectionObserver(handleFooterVisibility, {
                threshold: 0.01,
            });
            footerObserver.observe(footer);
        }
    };

    const enableStickyBuyBox = (mode) => {
        moveBuyBoxToBody();
        currentMode = mode;
        buyAndQty.classList.add('product__buy-and-qty--fixed');
        syncStickyPrice();
        updatePlaceholderHeight();
        observeStickyState();
        buyAndQty.classList.toggle('product__buy-and-qty--hidden', footerVisible);
        updateStickyOffset();
    };

    const disableStickyBuyBox = () => {
        if (!currentMode) return;

        currentMode = undefined;
        buyAndQty.classList.remove(
            'product__buy-and-qty--fixed',
            'product__buy-and-qty--hidden'
        );
        placeholder.style.removeProperty('height');
        disconnectStickyObservers();
        restoreBuyBoxPosition();
        updateStickyOffset();
    };

    const updateStickyBuyBox = () => {
        let nextMode;

        if (mobileBreakpoint.matches) {
            nextMode = 'mobile';
        } else if (desktopBreakpoint.matches && shouldStickOnDesktop) {
            nextMode = 'desktop';
        } else {
            nextMode = undefined;
        }

        if (nextMode) {
            enableStickyBuyBox(nextMode);
        } else {
            disableStickyBuyBox();
        }
    };

    const initialStickyThreshold = getDesktopStickyThreshold();
    const initialStickyViewportTop = window.scrollY + initialStickyThreshold;
    shouldStickOnDesktop = initialStickyViewportTop >= originalBuyBoxDocumentTop;
    updateStickyBuyBox();

    window.addEventListener('scroll', requestDesktopStickyUpdate, { passive: true });
    window.addEventListener('resize', requestDesktopStickyUpdate);

    if (mobileBreakpoint.addEventListener) {
        mobileBreakpoint.addEventListener('change', updateStickyBuyBox);
    } else {
        mobileBreakpoint.addListener(updateStickyBuyBox);
    }

    if (desktopBreakpoint.addEventListener) {
        desktopBreakpoint.addEventListener('change', requestDesktopStickyUpdate);
    } else {
        desktopBreakpoint.addListener(requestDesktopStickyUpdate);
    }

    stickyProductBuyBoxCleanup = () => {
        disableStickyBuyBox();

        if (desktopStickyFrame) {
            window.cancelAnimationFrame(desktopStickyFrame);
            desktopStickyFrame = undefined;
        }

        window.removeEventListener('scroll', requestDesktopStickyUpdate);
        window.removeEventListener('resize', requestDesktopStickyUpdate);

        if (mobileBreakpoint.removeEventListener) {
            mobileBreakpoint.removeEventListener('change', updateStickyBuyBox);
        } else {
            mobileBreakpoint.removeListener(updateStickyBuyBox);
        }

        if (desktopBreakpoint.removeEventListener) {
            desktopBreakpoint.removeEventListener('change', requestDesktopStickyUpdate);
        } else {
            desktopBreakpoint.removeListener(requestDesktopStickyUpdate);
        }

        placeholder.remove();
        stickyTrigger.remove();

        if (stickyProductBuyBoxElement === buyAndQty) {
            stickyProductBuyBoxElement = undefined;
        }

        stickyProductBuyBoxCleanup = undefined;
    };
};

const observeStickyProductBuyBox = () => {
    if (!isProductTemplate()) return;

    const ensureStickyProductBuyBox = () => {
        const currentBuyAndQty = document.querySelector('.product__buy-and-qty');

        if (!currentBuyAndQty) {
            stickyProductBuyBoxCleanup?.();
            return;
        }

        if (currentBuyAndQty !== stickyProductBuyBoxElement) {
            initStickyProductBuyBox();
        }
    };

    ensureStickyProductBuyBox();

    if (stickyProductBuyBoxObserver) return;

    stickyProductBuyBoxObserver = new MutationObserver(() => {
        ensureStickyProductBuyBox();
    });

    stickyProductBuyBoxObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });

    document.addEventListener('product-info:loaded', ensureStickyProductBuyBox);
};

const initMobileBreadcrumbs = () => {
    const breadcrumbs = Array.from(document.querySelectorAll('.breadcrumbs-container'));
    if (!breadcrumbs.length) return;

    const mobileBreakpoint = window.matchMedia('(max-width: 768px)');

    const createToggleSegment = (breadcrumb) => {
        const toggleSegment = document.createElement('span');
        toggleSegment.className = 'breadcrumb-segment breadcrumb-segment--toggle';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'breadcrumbs-toggle';
        button.textContent = '...';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Afficher tout le fil d\'ariane');

        button.addEventListener('click', () => {
            breadcrumb.classList.add('breadcrumbs-container--expanded');
            button.setAttribute('aria-expanded', 'true');
        });

        toggleSegment.appendChild(button);

        return toggleSegment;
    };

    const updateBreadcrumb = (breadcrumb) => {
        const children = Array.from(breadcrumb.children);
        const segments = children.filter((child) => child.classList?.contains('breadcrumb-segment') && !child.classList.contains('breadcrumb-segment--toggle'));
        const existingToggle = children.find((child) => child.classList?.contains('breadcrumb-segment--toggle'));
        const shouldCollapseOnDesktopProduct = isProductTemplate() && breadcrumb.scrollWidth > breadcrumb.clientWidth;

        segments.forEach((segment) => {
            segment.classList.remove('breadcrumb-segment--mobile-hidden');
        });

        breadcrumb.classList.remove('breadcrumbs-container--collapsible', 'breadcrumbs-container--expanded');
        existingToggle?.remove();

        if ((!mobileBreakpoint.matches && !shouldCollapseOnDesktopProduct) || segments.length <= 3) return;

        segments.slice(0, -2).forEach((segment) => {
            segment.classList.add('breadcrumb-segment--mobile-hidden');
        });

        const toggleSegment = createToggleSegment(breadcrumb);
        breadcrumb.insertBefore(toggleSegment, segments[segments.length - 2]);
        breadcrumb.classList.add('breadcrumbs-container--collapsible');
    };

    const updateBreadcrumbs = () => {
        breadcrumbs.forEach(updateBreadcrumb);
    };

    updateBreadcrumbs();

    if (mobileBreakpoint.addEventListener) {
        mobileBreakpoint.addEventListener('change', updateBreadcrumbs);
    } else {
        mobileBreakpoint.addListener(updateBreadcrumbs);
    }
};

let giftCardAmountPickerBound = false;

const parseGiftCardAmountValue = (value) => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : NaN;
    if (typeof value !== 'string') return NaN;

    const normalizedValue = value
        .replace(/\s+/g, '')
        .replace(/€/g, '')
        .replace(/,/g, '.');
    const numericValue = Number.parseFloat(normalizedValue.replace(/[^\d.-]/g, ''));

    return Number.isFinite(numericValue) ? numericValue : NaN;
};

const formatGiftCardAmountValue = (value) => {
    if (!Number.isFinite(value)) return '';

    return Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/\.00$/, '');
};

const areGiftCardAmountsEqual = (left, right) => Math.abs(left - right) < 0.001;

const getGiftCardAmountChoices = (picker) => {
    const select = picker?.querySelector('[data-gift-card-amount-select]');

    if (!select) return [];

    return Array.from(select.options)
        .map((option) => ({
            option,
            value: option.value,
            numericValue: parseGiftCardAmountValue(option.value || option.textContent || ''),
        }))
        .filter(({ numericValue }) => Number.isFinite(numericValue))
        .sort((left, right) => left.numericValue - right.numericValue);
};

const getNearestGiftCardAmountChoice = (availableAmounts, targetAmount) => {
    if (!availableAmounts.length) return null;

    const fallbackAmount = availableAmounts.find(({ option }) => option.selected) || availableAmounts[0];

    if (!Number.isFinite(targetAmount)) return fallbackAmount;

    return availableAmounts.reduce((closest, current) => {
        const currentDistance = Math.abs(current.numericValue - targetAmount);
        const closestDistance = Math.abs(closest.numericValue - targetAmount);

        if (currentDistance < closestDistance) return current;
        if (currentDistance === closestDistance && current.numericValue < closest.numericValue) return current;

        return closest;
    }, fallbackAmount);
};

const formatGiftCardAmountLabel = (value) => `${formatGiftCardAmountValue(value).replace('.', ',')} €`;

const clearGiftCardAmountFeedbackTimer = (picker) => {
    if (!picker?._giftCardAmountFeedbackTimer) return;

    window.clearTimeout(picker._giftCardAmountFeedbackTimer);
    delete picker._giftCardAmountFeedbackTimer;
};

const getGiftCardAmountValidationMessage = (availableAmounts) => {
    if (!availableAmounts.length) return 'Veuillez saisir un montant valide.';

    const uniqueAmounts = availableAmounts.reduce((amounts, { numericValue }) => {
        if (!amounts.some((value) => areGiftCardAmountsEqual(value, numericValue))) {
            amounts.push(numericValue);
        }

        return amounts;
    }, []);

    if (uniqueAmounts.length === 1) {
        return `Montant fixe : ${formatGiftCardAmountLabel(uniqueAmounts[0])}.`;
    }

    const steps = uniqueAmounts
        .slice(1)
        .map((value, index) => Number((value - uniqueAmounts[index]).toFixed(2)))
        .filter((value) => value > 0);

    const hasUniformStep = steps.length > 0 && steps.every((value) => areGiftCardAmountsEqual(value, steps[0]));

    if (hasUniformStep) {
        return `Montant compris entre ${formatGiftCardAmountLabel(uniqueAmounts[0])} et ${formatGiftCardAmountLabel(uniqueAmounts[uniqueAmounts.length - 1])} par palier de ${formatGiftCardAmountLabel(steps[0])}.`;
    }

    return `Montants disponibles : ${uniqueAmounts.map((value) => formatGiftCardAmountLabel(value)).join(', ')}.`;
};

const setGiftCardAmountErrorState = (picker, message = '', { persistMs = 0, forceClear = false } = {}) => {
    const input = picker?.querySelector('[data-gift-card-amount-input]');
    const errorContainer = picker?.querySelector('[data-gift-card-amount-error]');
    const errorMessage = errorContainer?.querySelector('.error-message');
    const hasError = Boolean(message);
    const activeFeedbackUntil = Number(picker?.dataset?.giftCardAmountFeedbackUntil || 0);

    if (!input || !errorContainer || !errorMessage) return;

    if (!hasError && !forceClear && activeFeedbackUntil > Date.now()) {
        return;
    }

    clearGiftCardAmountFeedbackTimer(picker);

    picker.classList.toggle('is-invalid', hasError);
    input.setCustomValidity(message);

    if (hasError) {
        if (persistMs > 0) {
            picker.dataset.giftCardAmountFeedbackUntil = String(Date.now() + persistMs);
            picker._giftCardAmountFeedbackTimer = window.setTimeout(() => {
                if (!document.body.contains(picker)) return;

                setGiftCardAmountErrorState(picker, '', { forceClear: true });
            }, persistMs);
        } else {
            delete picker.dataset.giftCardAmountFeedbackUntil;
        }

        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', errorContainer.id);
        errorContainer.removeAttribute('hidden');
        errorContainer.classList.remove('hidden');
        errorMessage.textContent = message;
        return;
    }

    delete picker.dataset.giftCardAmountFeedbackUntil;
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
    errorContainer.setAttribute('hidden', 'hidden');
    errorContainer.classList.add('hidden');
    errorMessage.textContent = '';
};

const syncGiftCardAmountInputFromSelect = (picker) => {
    const input = picker?.querySelector('[data-gift-card-amount-input]');
    const select = picker?.querySelector('[data-gift-card-amount-select]');

    if (!input || !select) return;

    const selectedOption = select.selectedOptions[0];
    const selectedAmount = parseGiftCardAmountValue(selectedOption?.value || selectedOption?.textContent || '');

    if (Number.isFinite(selectedAmount)) {
        input.value = formatGiftCardAmountValue(selectedAmount);
    }

    setGiftCardAmountErrorState(picker);
};

const syncGiftCardAmountSelect = (picker, amountChoice, { dispatchChange = true } = {}) => {
    const input = picker?.querySelector('[data-gift-card-amount-input]');
    const select = picker?.querySelector('[data-gift-card-amount-select]');

    if (!input || !select || !amountChoice) return;

    if (select.value === amountChoice.value) return;

    select.value = amountChoice.value;

    if (dispatchChange) {
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }
};

const validateGiftCardAmount = (
    picker,
    rawValue,
    { syncSelect = false, dispatchChange = true, normalizeInput = false, showError = true, autoCorrect = false, invalidMessage = '' } = {}
) => {
    const input = picker?.querySelector('[data-gift-card-amount-input]');
    const availableAmounts = getGiftCardAmountChoices(picker);

    if (!input || !availableAmounts.length) return true;

    const targetAmount = parseGiftCardAmountValue(rawValue ?? input.value);
    const matchingAmount = Number.isFinite(targetAmount)
        ? availableAmounts.find(({ numericValue }) => areGiftCardAmountsEqual(numericValue, targetAmount))
        : null;

    if (!matchingAmount) {
        const nearestAmount = getNearestGiftCardAmountChoice(availableAmounts, targetAmount);

        if (autoCorrect && nearestAmount) {
            input.value = formatGiftCardAmountValue(nearestAmount.numericValue);

            if (syncSelect) {
                syncGiftCardAmountSelect(picker, nearestAmount, { dispatchChange });
            }

            if (showError) {
                setGiftCardAmountErrorState(
                    picker,
                    `Montant ajusté à ${formatGiftCardAmountLabel(nearestAmount.numericValue)}.`,
                    { persistMs: 2500 }
                );
            } else {
                setGiftCardAmountErrorState(picker);
            }

            return true;
        }

        if (showError) {
            setGiftCardAmountErrorState(picker, invalidMessage || getGiftCardAmountValidationMessage(availableAmounts));
        } else {
            setGiftCardAmountErrorState(picker);
        }

        return false;
    }

    if (normalizeInput) {
        input.value = formatGiftCardAmountValue(matchingAmount.numericValue);
    }

    setGiftCardAmountErrorState(picker);

    if (syncSelect) {
        syncGiftCardAmountSelect(picker, matchingAmount, { dispatchChange });
    }

    return true;
};

const bindGiftCardAmountPickerSubmit = (picker) => {
    const select = picker?.querySelector('[data-gift-card-amount-select]');
    const form = select?.form;

    if (!form || picker.dataset.giftCardAmountSubmitBound === 'true') return;

    picker.dataset.giftCardAmountSubmitBound = 'true';

    form.addEventListener('submit', (event) => {
        const isValid = validateGiftCardAmount(picker, undefined, {
            syncSelect: true,
            dispatchChange: true,
            normalizeInput: true,
            showError: true,
            autoCorrect: true,
        });

        if (isValid) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        picker.querySelector('[data-gift-card-amount-input]')?.focus();
    }, true);
};

const initGiftCardAmountPickers = () => {
    document.querySelectorAll('[data-gift-card-amount-picker]').forEach((picker) => {
        syncGiftCardAmountInputFromSelect(picker);
        bindGiftCardAmountPickerSubmit(picker);
    });

    if (giftCardAmountPickerBound) return;

    giftCardAmountPickerBound = true;

    document.addEventListener('change', (event) => {
        const amountInput = event.target.closest('[data-gift-card-amount-input]');
        if (amountInput) {
            validateGiftCardAmount(amountInput.closest('[data-gift-card-amount-picker]'), amountInput.value, {
                syncSelect: true,
                dispatchChange: true,
                normalizeInput: true,
                showError: true,
                autoCorrect: true,
            });
            return;
        }

        const amountSelect = event.target.closest('[data-gift-card-amount-select]');
        if (amountSelect) {
            syncGiftCardAmountInputFromSelect(amountSelect.closest('[data-gift-card-amount-picker]'));
        }
    });

    document.addEventListener('blur', (event) => {
        const amountInput = event.target.closest('[data-gift-card-amount-input]');
        if (!amountInput) return;

        validateGiftCardAmount(amountInput.closest('[data-gift-card-amount-picker]'), amountInput.value, {
            syncSelect: true,
            dispatchChange: true,
            normalizeInput: true,
            showError: true,
            autoCorrect: true,
        });
    }, true);

    document.addEventListener('input', (event) => {
        const amountInput = event.target.closest('[data-gift-card-amount-input]');
        if (!amountInput) return;

        const picker = amountInput.closest('[data-gift-card-amount-picker]');
        const availableAmounts = getGiftCardAmountChoices(picker);

        validateGiftCardAmount(picker, amountInput.value, {
            syncSelect: true,
            dispatchChange: true,
            normalizeInput: false,
            showError: true,
            invalidMessage: getGiftCardAmountValidationMessage(availableAmounts),
        });
    });

    document.addEventListener('keydown', (event) => {
        const amountInput = event.target.closest('[data-gift-card-amount-input]');
        if (!amountInput || event.key !== 'Enter') return;

        event.preventDefault();
        const picker = amountInput.closest('[data-gift-card-amount-picker]');
        const isValid = validateGiftCardAmount(picker, amountInput.value, {
            syncSelect: true,
            dispatchChange: true,
            normalizeInput: true,
            showError: true,
            autoCorrect: true,
        });

        if (isValid) {
            amountInput.blur();
            return;
        }

        amountInput.focus();
    });
};

const initScrollToTopButton = () => {
    const button = document.getElementById('scroll-to-top-button');

    if (!button || button.dataset.initialized === 'true') return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    button.dataset.initialized = 'true';

    const toggleVisibility = () => {
        const isVisible = window.scrollY > 500;
        button.classList.toggle('is-visible', isVisible);
        button.toggleAttribute('hidden', !isVisible);
    };

    button.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
        });
    });

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
};

document.addEventListener('DOMContentLoaded', () => {
    togglePasswordVisibility();
    initSwiperSubCategories();
    initAccountActivation();
    initRecoverPasswordCheck();
    initPredictiveSearch();
    initModals();
    observeStickyProductBuyBox();
    initMobileBreadcrumbs();
    initGiftCardAmountPickers();
    initScrollToTopButton();
    if (window.innerWidth > 768) {
        $menuDrawer = document.querySelector('.menu-drawer');
        if ($menuDrawer) {
            $menuDrawer.querySelectorAll('details').forEach(($details) => {
                $details.addEventListener('mouseenter', () => {
                    clearTimeout($details.closeTimeout);
                });
        
                $details.addEventListener('mouseleave', () => {
                    $details.closeTimeout = setTimeout(() => {
                        $details.removeAttribute('open');
                    }, 300); // Adjust the delay as needed
                });
        
                $details.querySelectorAll('summary').forEach(($summary) => {
                    $summary.addEventListener('mouseenter', (event) => {
                        clearTimeout($details.closeTimeout);
                        if (!$details.attributes['open']) {
                            $menuDrawer.querySelectorAll('details').forEach(($allDetailItem) => {
                                if ($details.id !== $allDetailItem.id && !$allDetailItem.contains($details)) {
                                    $allDetailItem.removeAttribute('open');
                                }
                            });
                            event.target.click();
                        }
                    });
                });
            });
        }
        initProductCoverSlider();
        initTooltips();
        
    } else {
        initSwipers();
        document.addEventListener("productRecommendationsLoaded", initSwipers);
    }

    initProductsHighlightSwipers();
    document.addEventListener("productRecommendationsLoaded", initProductsHighlightSwipers);
    
    const elementsToMove = document.querySelectorAll("[data-move-to]");
    elementsToMove.forEach(element => {
        const originalParent = element.parentElement; // Sauvegarde du parent d'origine
        const originalNextSibling = element.nextElementSibling; // Sauvegarde de la position

        const moveElement = () => {
            const targetSelector = element.getAttribute("data-move-to");
            const target = document.querySelector(targetSelector);

            if (window.innerWidth <= 768) {
                if (target && !target.contains(element)) {
                    target.appendChild(element);
                }
            } else {
                if (originalParent && !originalParent.contains(element)) {
                    if (originalNextSibling) {
                        originalParent.insertBefore(element, originalNextSibling);
                    } else {
                        originalParent.appendChild(element);
                    }
                }
            }
        };

        moveElement();
        window.addEventListener("resize", moveElement);
    });

    const headerSearchToggles = document.querySelectorAll('[data-focus-input]');
    if (headerSearchToggles.length) {
        headerSearchToggles.forEach(($headerSearchToggle) => {
            $headerSearchToggle.addEventListener('click', (e) => {
                e.preventDefault();
    
                const $realSearchField = document.querySelector($headerSearchToggle.dataset.focusInput);
                if ($realSearchField) {
                    setTimeout(() => {
                        $realSearchField.focus();
                    }, 300);
                }
            });
        });
    }

    const clickElements = document.querySelectorAll('[data-click]');
    if (clickElements.length) {
        clickElements.forEach((clickElement) => {
            clickElement.addEventListener('click', (e) => {
                e.preventDefault();
                const target = document.querySelector(clickElement.dataset.click);
                if (target) {
                    target.click();
                    // If mobile, scroll the target to the top of the viewport minus the header height
                    const scrollTop = window.innerWidth <= 768 
                        ? target.offsetTop - document.querySelector('.header-wrapper').offsetHeight 
                        : target.offsetTop - document.querySelector('.header-wrapper').offsetHeight - 150;
                    window.scrollTo({top: scrollTop, behavior: 'smooth'});
                }
            });
        });
    }

    const $cartKingModal = document.querySelector('#cartKingModal');
    if ($cartKingModal) {
        const $cartKingModalH2 = $cartKingModal.querySelector('h2');
        if ($cartKingModalH2) {
            $cartKingModalH2.parentElement.removeChild($cartKingModalH2);
        }
    }

    if (document.body.dataset.template === "cart") {
        initCart();
    }
});